import script from "./ModalSuccess.vue?vue&type=script&lang=js"
export * from "./ModalSuccess.vue?vue&type=script&lang=js"

import "./ModalSuccess.vue?vue&type=style&index=0&id=4c147608&lang=css"

const __exports__ = script;

export default __exports__